<template>

    <!-- Main Sidebar -->
    <component :is="navbarFixed ? 'a-affix' : 'div'" :offset-top="top">

        <!-- Layout Header -->
        <a-layout-header>
            <a-row type="flex">

                <!-- Header Breadcrumbs & Title Column -->
                <a-col :span="24" :md="6">

                    <!-- Header Breadcrumbs -->
                    <a-breadcrumb>
                        <a-breadcrumb-item>
                            <router-link to="/"> صفحه</router-link>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>{{ this . $route . name }}</a-breadcrumb-item>
                    </a-breadcrumb>
                    <!-- / Header Breadcrumbs -->

                    <!-- Header Page Title -->
                    <div class="ant-page-header-heading">
                        <span class="ant-page-header-heading-title">{{ this . $route . name }}</span>
                    </div>
                    <!-- / Header Page Title -->

                </a-col>
                <!-- / Header Breadcrumbs & Title Column -->

                <!-- Header Control Column -->
                <a-col :span="24" :md="18" class="header-control">
                    <!-- Header Control Buttons -->

                    <a-button type="link" class="btn-sign-in" @click="logout()">
                        <a-icon type="logout" />
                        <span>خروج</span>
                    </a-button>
                    <a-button type="link" class="sidebar-toggler"
                        @click="$emit('toggleSidebar', ! sidebarCollapsed) , resizeEventHandler()">
                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path
                                d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" />
                        </svg>
                    </a-button>

                    <!-- / Header Control Buttons -->



                </a-col>
                <!-- / Header Control Column -->

            </a-row>
        </a-layout-header>
        <!--  /Layout Header -->

    </component>
    <!-- / Main Sidebar -->

</template>

<script>
    const notificationsData = [{
            title: 'یک پیام جدید از آقای مرادی دارید',
            img: 'images/face-2.jpg',
            time: '۱۳ دقیقه پیش',
        },
        {
            title: 'یک پیام جدید از آقای سعیدی دارید',
			img: 'images/face-6.jpeg',
            time: '۱ روز پیش',
        },
        {
            title: 'پرداخت کامل شد',
            svg: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill="#1890FF" d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"/>
					<path fill="#1890FF" fill-rule="evenodd" clip-rule="evenodd" d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"/>
				</svg>`,
            time: '۲ روز پیش',
        },
    ];

    export default ({
        props: {
            // Header fixed status.
            navbarFixed: {
                type: Boolean,
                default: true,
            },

            // Sidebar collapsed status.
            sidebarCollapsed: {
                type: Boolean,
                default: false,
            },

            // Header notifications data.
            notificationsData: {
                type: Array,
                default: () => notificationsData,
            },
        },
        data() {
            return {
                // Fixed header/sidebar-footer ( Affix component ) top offset.
                top: 0,

                // Search input loading status.
                searchLoading: false,

                // The wrapper element to attach dropdowns to.
                wrapper: document.body,
            }
        },
        methods: {
            async logout() {
                const _this = this;
                await axios
                    .get("/logout")
                    .then(function(response) {
                        const data = response.data;
                        _this.$toast.success(data.message);
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
                _this.$store.commit('logout');

            },
            resizeEventHandler() {
                this.top = this.top ? 0 : -0.01;
                // To refresh the header if the window size changes.
                // Reason for the negative value is that it doesn't activate the affix unless
                // scroller is anywhere but the top of the page.
            },
            onSearch(value) {}
        },
        mounted: function() {
            // Set the wrapper to the proper element, layout wrapper.
            this.wrapper = document.getElementById('layout-dashboard');
        },
        created() {
            // Registering window resize event listener to fix affix elements size
            // error while resizing.
            window.addEventListener("resize", this.resizeEventHandler);
        },
        destroyed() {
            // Removing window resize event listener.
            window.removeEventListener("resize", this.resizeEventHandler);
        },
    })
</script>
